// extracted by mini-css-extract-plugin
module.exports = {"megabanner-derecha":"styles_megabanner-derecha__l6RKL"};